import React, { useContext } from 'react';
import { Typography } from 'antd';

import DeviceEndOfSupportContext from '@totem/components/deviceEndOfSupport/deviceEndOfSupportContext';

// Generated from the loaded data so the notes stay true as the data changes.
const DataNotes = () => {
  const { rows, coverage } = useContext(DeviceEndOfSupportContext);

  const total = rows.length;
  const estimated = rows.filter((row) => row.estimated).length;
  const eolFirst = rows.filter((row) => row.eolFirst).length;
  const conflicts = rows.filter((row) => row.status === 'check');
  const hardware = rows.filter(
    (row) => row.productType && row.productType !== 'Operating System',
  ).length;
  const noDate = rows.filter((row) => row.status === 'none').length;

  const unrated = coverage
    ? coverage.withoutRecord.managed + coverage.withoutRecord.notManaged
    : 0;
  const estate = coverage
    ? unrated + coverage.withRecord.managed + coverage.withRecord.notManaged
    : 0;

  return (
    <>
      <Typography.Title level={5}>About these dates</Typography.Title>
      <ul>
        {coverage && (
          <li>
            <strong>
              Only {total} of {estate.toLocaleString('en-US')} devices have a
              lifecycle record.
            </strong>{' '}
            The rest are not rated, so this screen shows part of the estate, not
            all of it. {coverage.withoutRecord.managed} of the unrated devices
            are under IB management.
          </li>
        )}
        <li>
          <strong>
            {estimated} of {total} devices have lifecycle dates that were
            estimated automatically
          </strong>
          , not taken from the manufacturer. Treat them as a guide and confirm
          before budgeting a replacement.
        </li>
        <li>
          <strong>
            {eolFirst} devices show an End of Life date earlier than their End
            of Support date.
          </strong>{' '}
          They are marked &ldquo;Before end of support&rdquo; in the table.
          Vendors normally end support first, so these dates need checking.
        </li>
        {conflicts.length > 0 && (
          <li>
            <strong>
              {conflicts.length} devices show an End of Support date that does
              not fit their operating system
            </strong>{' '}
            ({conflicts.map((row) => row.name).join(', ')}). The OS was released
            after that date, so it almost certainly belongs to the hardware.
            They are marked &ldquo;Date needs checking&rdquo;, not &ldquo;Past
            end of service&rdquo;.
          </li>
        )}
        <li>
          <strong>
            Most dates describe the hardware, not the operating system.
          </strong>{' '}
          {hardware} of {total} devices are matched on a hardware product type,
          so a device can run a current Windows version and still show an old
          date.
        </li>
        <li>
          <strong>{noDate} devices have no End of Support date</strong>{' '}
          (including any marked &ldquo;Not yet announced&rdquo;), so they cannot
          be rated.
        </li>
      </ul>
    </>
  );
};

export default DataNotes;
